module.exports = __webpack_public_path__ + "static/img/icon4-6.04ec2ad9.png";